import { connect } from 'react-redux'
import { getUser, getUserLang } from '../../selectors/user'
import { getActiveLanguage, getLanguages, getTranslate, withLocalize } from 'react-localize-redux'
import { hideModal, showModal } from '../../actions/modal'
import { useEffect, useState } from 'react'
import { AlternativeSupport } from './AlternativeSupport/AlternativeSupport'
import { useWindowSize } from 'common/hooks/useWindowSize'
const SupportButton = props => {
  const { isMobile } = useWindowSize()

  const [beaconLoaded, setBeaconLoaded] = useState(false)
  const [beaconBlocked, setBeaconBlocked] = useState(false)
  const { translate } = props

  useEffect(() => {
    let beaconTimeout
    if (isMobile) {
      const style = document.createElement('style')
      style.innerHTML = `
        #beacon-container {

          position: fixed !important;
          z-index: 99 !important;
        }
      .c-BeaconCloseButton {
        position: fixed !important;
        z-index: 999999 !important;
        top: 10px !important;
        right: 10px !important;
      }
      `
      document.head.appendChild(style)
    }

    const loadBeacon = () => {
      ;(function (e, t, n) {
        function a() {
          var e = t.getElementsByTagName('script')[0]
          var n = t.createElement('script')
          n.type = 'text/javascript'
          n.async = true
          n.src = 'https://beacon-v2.helpscout.net'
          n.onload = () => {
            if (isMobile) {
              window.Beacon('config', {
                display: {
                  position: 'left'
                }
              })
            }
            setBeaconLoaded(true) // Marcamos que el script se ha cargado
            const interval = setInterval(() => {
              const beacon = document.getElementById('beacon-container')
              if (beacon) {
                beacon.style.zIndex = '99'
                clearInterval(interval)
              }
            }, 100)
          }
          n.onerror = () => {
            setBeaconBlocked(true) // Marcamos que el script fue bloqueado o no se pudo cargar
          }
          e.parentNode.insertBefore(n, e)
        }
        if (
          ((e.Beacon = n =
            function (t, n, a) {
              e.Beacon.readyQueue.push({ method: t, options: n, data: a })
            }),
          (n.readyQueue = []),
          t.readyState === 'complete')
        )
          return a()
        e.attachEvent ? e.attachEvent('onload', a) : e.addEventListener('load', a, false)
      })(window, document, window.Beacon || function () {})

      window.Beacon('init', 'ba1f6d2a-b28d-4296-ad43-d4dbc62c1644')

      beaconTimeout = setTimeout(() => {
        if (!beaconLoaded) {
          setBeaconBlocked(true) // Si el script no se ha cargado después de un tiempo, lo marcamos como bloqueado
        }
      }, 3000) // Puedes ajustar este tiempo según tus necesidades
    }

    loadBeacon()

    return () => {
      clearTimeout(beaconTimeout)
      window.Beacon('destroy')
    }
  }, [beaconLoaded, isMobile])

  if (beaconBlocked) {
    return <AlternativeSupport translate={translate} />
  }

  return null // Este componente no necesita renderizar nada en la interfaz de usuario si Beacon se carga correctamente
}

const mapStateToProps = state => ({
  user: getUser(state),
  userLanguage: getUserLang(state),
  activeLanguage: getActiveLanguage(state.localize),
  languages: getLanguages(state.localize),
  translate: getTranslate(state.localize)
})

const mapActionsToProps = {
  showModal,
  hideModal
}

export default withLocalize(connect(mapStateToProps, mapActionsToProps)(SupportButton))
